// extracted by mini-css-extract-plugin
export default {"fallbackMain":"fallback_fallbackMain__KQatQ"};